import * as React from 'react';
import { EHeaderType, IArticle } from '../types';
import './StaticPages.scss';

export function renderArticle(article: IArticle) {
  if (article.draft || article.outdated) return;
  if (!article.body || article.body.length === 0) {
    return <React.Fragment key={article.title}>{renderHeader(article.title, article.type)}</React.Fragment>;
  }
  const body = {
    __html: article.body,
  };
  return (
    <React.Fragment key={article.title}>
      {renderHeader(article.title, article.type)}
      <div className="article-body" role="article" dangerouslySetInnerHTML={body} />
    </React.Fragment>
  );
}

export function renderHeader(header: string, type: EHeaderType) {
  if (!header || header.length === 0) return;
  switch (type) {
    case EHeaderType.header1:
      return <h1 className={type + ' article-header'}>{header}</h1>;
    case EHeaderType.header2:
      return <h2 className={type + ' article-header'}>{header}</h2>;
    case EHeaderType.header3:
      return <h3 className={type + ' article-header'}>{header}</h3>;
  }
}
